import debounce from 'lodash/debounce';

export default (func, debounceTime) => debounce(func, debounceTime);
